export default __webpack_public_path__ + "static/media/colour-light-background.8b058e4c.svg";